import styled from 'styled-components'

import { Container, Image } from 'semantic-ui-react'
import {Link} from "@/components/OtherCustomComponents/style";

export const HeaderContainer = styled(Container)`
    &:before, &:after {
        content: none;
    }
    && {
        display: flex;
        justify-content: space-between;
        line-height: 1.2rem;
        padding: 0.2rem 1rem;
        min-height: 65px;
        row-gap: 5px;

        @media (max-width: 1199px) {
            flex-wrap: wrap;
        }

        &>div {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            row-gap: 3px;
        }

        &>div:last-child{
            margin-left: auto;
        }

        @media (min-width: 768px) {
            &>div:last-child{
                flex-shrink: 0;
            }
        }

        @media (max-width: 767px) {
            padding-left: 0;
            padding-right: 0;

            &>div {
                margin-top: 5px;
            }

            &>div:last-child{
                flex-wrap: wrap;
                margin: auto;
            }
        }

        & .ui.button {
            font-size: 16px;
        }
    }
`
export const LogoLink = styled.a`
    display: contents;
`
export const Logo = styled(Image)`
    /* width: 61px; */
    max-height: 40px;
    margin-right: 1rem;
`
export const StyledText = styled.span`
    font-size: 18px;
    margin-right: auto;
    a {
        color: inherit;
    }
`

type Props = {
    $color: string,
}
export const ThemedLink = styled(Link)<Props>`
    color: ${({ $color }) => $color};
    font-size: 16px;
    margin: 0 .5em;
`